import React from "react";
import Map from "../../components/common/Map";

function Chat() {
  return (
    <section id="contact" className="tc-chat-style1">
      <div className="container">
        <div className="content-map">
          <div className="content">
            <h2 className="xl-text">اتصل بنا</h2>
            <p className="mb-50">
              مستعد لتحويل رؤيتك إلى واقع؟ تواصل مع تعمير للبناء والتطوير عبر
              البريد الإلكتروني، أو بزيارة مكتبنا. فريقنا هنا لمناقشة احتياجات
              مشروعك والإجابة على أي استفسارات.
            </p>

            <div className="d-flex flex-column gap-3">
              <div className="d-flex fs-6">
                <div>
                  <i
                    className="la la-map-marker fs-4"
                    style={{ color: "var(--color-primary-custom)" }}
                  ></i>
                </div>
                <div className="ps-10">
                  <span className="fw-600 d-block">موقعنا</span>
                  <span>
                    283 عبد المنعم رياض، مبنى 2، كومباوند الفرسان، الوحدة 2301،
                    السياحي السادس، المحور المركزي، 6 أكتوبر
                  </span>
                </div>
              </div>

              <div className="d-flex fs-6">
                <div>
                  <i
                    className="la la-envelope fs-4"
                    style={{ color: "var(--color-primary-custom)" }}
                  ></i>
                </div>
                <div className="ps-10">
                  <span className="fw-600 d-block">البريد الإلكتروني</span>
                  <a href="mailto:info@tameer-egypt.com">
                    info@tameer-egypt.com
                  </a>
                </div>
              </div>
            </div>
          </div>
          <Map />
        </div>
      </div>
      <img src="/home1/assets/img/c_line4.webp" alt="" className="c-line wow" />
    </section>
  );
}

export default Chat;
